export const DEFAULT_SLIDE_DURATION_MS = 15_000;
export const MIN_AUTO_PLAY_INTERVAL_SECONDS = 3;
export const MAX_AUTO_PLAY_INTERVAL_SECONDS = 60;

export function autoPlayIntervalMsToSeconds(
  ms: number | null | undefined,
): number {
  if (typeof ms !== 'number' || !Number.isFinite(ms) || ms <= 0) {
    return DEFAULT_SLIDE_DURATION_MS / 1000;
  }
  return Math.round(ms / 1000);
}

export function secondsToAutoPlayIntervalMs(seconds: number): number {
  const clamped = Math.min(
    MAX_AUTO_PLAY_INTERVAL_SECONDS,
    Math.max(MIN_AUTO_PLAY_INTERVAL_SECONDS, Math.round(seconds)),
  );
  return clamped * 1000;
}
